module.exports = __webpack_public_path__ + "static/media/r28.326675b9.webp";